import { collapse, expand } from '../expandable/expandable-transition';
import { createNotification, showNotification } from '../notification/notification';

export function createMessageContainer(parent) {
	let messages = parent.querySelector('[data-form="messages"]');

	if (!messages) {
		messages = document.createElement('div');

		parent.appendChild(messages);
	}

	return messages;
}

export function showMessage(messages, content, options = {}) {
	if (!content) {
		return;
	}

	const notification = options.error
		? null
		: createNotification({
				message: content
		  });

	if (options.error || !notification) {
		const message = document.createElement('div');

		message.innerHTML = content;
		message.classList.add('ln-form__message');
		message.setAttribute('role', 'alert');

		if (options.error) {
			message.classList.add('ln-form__message--error');
		}

		if (!options.keepPosition) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}

		const animate = () => {
			// Empty container and add message
			messages.innerHTML = '';
			messages.appendChild(message);

			expand(messages);
		};

		// Animate
		if (options.isCollapsing) {
			options.isCollapsing.then(() => animate());
		} else {
			animate();
		}
	} else {
		showNotification(notification, {
			timeout: 4000
		});
	}
}

export function hideMessages(messages, isCollapsing) {
	if (messages.innerHTML !== '') {
		isCollapsing = collapse(messages).then(() => {
			messages.innerHTML = '';

			isCollapsing = false;
		});
	}

	return isCollapsing;
}
